import {Injectable} from '@angular/core';
import {BaseEndpointService} from '../base-endpoint-service';
import {Backend} from '@generated-backend-types';
import {ListItem} from "src/app/entities/list-item.entity";
import Process = Backend.App.Resources.Dashboard.QualityManagement.Process;
import ProcessData = Backend.App.Data.Dashboard.QualityManagement.ProcessData;

@Injectable({providedIn: 'root'})
export class ProcessService extends BaseEndpointService<Process, ProcessData> {
  protected override endpoint = '/quality-management/processes';

  public override modelToMultiSelectItem(m: Process): ListItem & { model: Process; } {
    return {
      id: m.id,
      text: m.title ? `${m.ext_id} - ${m.title}` : m.ext_id,
      isDisabled: false,
      model: m,
    }
  }
}
